// import React from 'react';

// import { Link, useLocation } from 'react-router-dom';

// export default function Navibar(props) {
// 	const location = useLocation();
//   return (
//     <header id="header">
// 			<div className="startp-mobile-nav">
// 				<div className="logo">
// 					<Link to="/VHome"><a href="/VHome"><img src="/img/vsk-logo.png" alt="logo"/></a></Link>
// 				</div>
// 			</div>

// 			<div className="startp-nav">
// 				<div className="container">
// 					<nav className="navbar navbar-expand-md navbar-light">
// 					<Link to="/VHome"><a className="navbar-brand" href="/VHome"><img src="/img/vsk-logo.png" alt="logo" width="200"/></a></Link>

// 						<div className="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
// 							<ul className="navbar-nav nav ml-auto">
// 							<li className={`nav-item ${location.pathname === '/VHome' ? 'active' : ''}`}>
//                     <Link to="/VHome" className="nav-link">Home</Link>
//                 </li>
//                 <li className={`nav-item ${location.pathname === '/VSKAbout' ? 'active' : ''}`}>
//                     <Link to="/VSKAbout" className="nav-link">About us</Link>
//                 </li>
//                 <li className={`nav-item ${location.pathname === '/VSKQuality' ? 'active' : ''}`}>
//                     <Link to="/VSKQuality" className="nav-link">Quality</Link>
//                 </li>
//                 <li className={`nav-item ${location.pathname === '/Fabrics' ? 'active' : ''}`}>
//                     <Link to="/Fabrics" className="nav-link">Fabrics</Link>
//                 </li>
//                 <li className={`nav-item ${location.pathname === '/Contact' ? 'active' : ''}`}>
//                     <Link to="/Contact" className="nav-link">Contact</Link>
//                 </li>
// 				</ul>
// 						</div>

// 					</nav>
// 				</div>
// 			</div>
// 		</header>
//   )
// }

import React from "react";
import * as Icon from "react-feather";
import { Link, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function Navibar() {
  const location = useLocation();
  const [state, setState] = React.useState({ right: false });
  const [submenuOpen, setSubmenuOpen] = React.useState(false); // Control visibility of Products submenu
  const isMobile = useMediaQuery("(max-width: 992px)");

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ right: open });
  };

  const navItems = [
    { path: "/VHome", label: "Home" },
    { path: "/VSKAbout", label: "About Us" },
    { path: "/VSKQuality", label: "Quality" },
    { path: "/Certifications", label: "Certifications" },
    {
      path: "#",
      label: "Products",
      subItems: [
        { path: "/Bed", label: "Bed Linen" },
        { path: "/Bath", label: "Bath Linen" },
        { path: "/Banquet", label: "Banquet Linen" },
        { path: "/Tote", label: "Tote Bags" },
        { path: "/Fabrics", label: "Fabrics" },
      ],
    },
    { path: "/Contact", label: "Contact" },
  ];

  const handleMouseEnter = () => {
    setSubmenuOpen(true);
  };

  const handleMouseLeave = () => {
    setSubmenuOpen(false);
  };

  const renderNavItem = (item) => (
    <ListItem
      key={item.path}
      disablePadding
      onMouseEnter={item.subItems ? handleMouseEnter : null}
      onMouseLeave={item.subItems ? handleMouseLeave : null}
    >
      <ListItemButton
        component={Link}
        to={item.path}
        onClick={
          item.subItems ? (e) => e.preventDefault() : toggleDrawer(false)
        } // Prevent default navigate for dropdown
      >
        <ListItemText primary={item.label} />
        {item.subItems && <Icon.ChevronDown style={{ marginLeft: "auto" }} />}
      </ListItemButton>
      {item.subItems && submenuOpen && (
        <List component="div" disablePadding style={{ paddingLeft: "1rem" }}>
          {item.subItems.map((subItem) => (
            <ListItem key={subItem.path} disablePadding>
              <ListItemButton
                component={Link}
                to={subItem.path}
                onClick={toggleDrawer(false)}
              >
                <ListItemText primary={subItem.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      )}
    </ListItem>
  );

  const list = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>{navItems.map((item) => renderNavItem(item))}</List>
      <Divider />
    </Box>
  );

  return (
    <header id="header">
      <div className="startp-mobile-nav">
        <div className="logo">
          <Link to="/VHome">
            <img src="/img/vsk-logo.png" alt="logo" />
          </Link>
        </div>
        {isMobile && (
          <Button
            onClick={toggleDrawer(true)}
            color="primary"
            sx={{ position: "absolute", right: 16, top: 16, zIndex: 100 }}
          >
            <Icon.Menu />
          </Button>
        )}
      </div>

      <div className="startp-nav">
        <div className="container">
          <nav className="navbar navbar-expand-md navbar-light">
            <Link to="/VHome">
              <img src="/img/vsk-logo.png" alt="logo" width="200" />
            </Link>

            {/* Display the normal menu on desktop */}
            {!isMobile && (
              <div
                className="collapse navbar-collapse mean-menu"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav nav ml-auto">
                  {navItems.map((item) => (
                    <li
                      className={`nav-item ${
                        location.pathname === item.path ? "active" : ""
                      }`}
                      key={item.path}
                    >
                      {item.subItems ? (
                        <div
                          onMouseEnter={handleMouseEnter}
                          onMouseLeave={handleMouseLeave}
                        >
                          <Link to="#" className="nav-link">
                            {item.label} <Icon.ChevronDown />
                          </Link>

                          {submenuOpen && (
                            <ul
                              className="dropdown-menu"
                              style={{ padding: 0 }}
                            >
                              {item.subItems.map((subItem) => (
                                <li key={subItem.path} style={{ padding: 10 }}>
                                  <Link
                                    to={subItem.path}
                                    className={`dropdown-item ${
                                      location.pathname === subItem.path
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {subItem.label}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        <Link to={item.path} className="nav-link">
                          {item.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Mobile Drawer Menu */}
            <SwipeableDrawer
              anchor="right"
              open={state.right}
              onClose={toggleDrawer(false)}
              onOpen={toggleDrawer(true)}
            >
              {list()}
            </SwipeableDrawer>
          </nav>
        </div>
      </div>
    </header>
  );
}
